import { useState } from 'react';
import { emitEvent } from '@jove-frontend/utils';
import { supportTranslationCountryConvertMap } from '../constants/country';
export var JOVE_LOCAL_LOCALE_COUNTRY_KEY = 'jove-local-locale-country-key';
export var JOVE_DEFAULT_LOCALE_COUNTRY = 'GB';
export var useLocaleSwitch = function useLocaleSwitch() {
  var _localStorage;

  var _useState = useState(((_localStorage = localStorage) === null || _localStorage === void 0 ? void 0 : _localStorage.getItem(JOVE_LOCAL_LOCALE_COUNTRY_KEY)) || 'GB'),
      currentLocaleCountry = _useState[0],
      setCurrentLocaleCountry = _useState[1];
  /**
   * methods
   */


  var modifyCurrentLocaleCountry = function modifyCurrentLocaleCountry(country) {
    var _localStorage2;

    setCurrentLocaleCountry(country);
    (_localStorage2 = localStorage) === null || _localStorage2 === void 0 ? void 0 : _localStorage2.setItem(JOVE_LOCAL_LOCALE_COUNTRY_KEY, country);
    setTimeout(function () {
      emitEvent('jove-local-locale-change', {
        country: country
      });
    }, 0);
  };

  var getLocaleReleatedRequestParams = function getLocaleReleatedRequestParams(info) {
    var _supportTranslationCo;

    return {
      client_from: (info === null || info === void 0 ? void 0 : info.clientFrom) || 'quote',
      client_lng: (_supportTranslationCo = supportTranslationCountryConvertMap[localStorage.getItem(JOVE_LOCAL_LOCALE_COUNTRY_KEY) || 'GB']) === null || _supportTranslationCo === void 0 ? void 0 : _supportTranslationCo.locale
    };
  };

  return {
    currentLocaleCountry: currentLocaleCountry,
    modifyCurrentLocaleCountry: modifyCurrentLocaleCountry,
    getLocaleReleatedRequestParams: getLocaleReleatedRequestParams
  };
};